/**
 * What the index route calls itself.
 *
 * Shared with the global nav rather than inlined in the page: `usePageTitle`
 * announces this string on navigation, so a nav item naming the route something
 * else would have a reader activate one name and hear another.
 */
export const AUDIOGAME_LIST_TITLE = "AudioGame Registry";
